import { ObjectEntityItem } from '@ekt-group/general-purpose-api-interfaces';
import { useMemo } from 'react';

export const useGetObjectItemsByObjectId = (objectItems: ObjectEntityItem[] | undefined) => {
  return useMemo(() => {
    if (!objectItems) {
      return {};
    }

    return objectItems.reduce((accumulator, objectItem) => {
      if (!accumulator[objectItem.objectId]) {
        accumulator[objectItem.objectId] = [];
      }
      accumulator[objectItem.objectId].push(objectItem);
      return accumulator;
    }, {} as Record<number, ObjectEntityItem[]>);
  }, [objectItems]);
};
